import { createFileRoute } from "@tanstack/react-router";
import { canonicalLink, pathFromMatch, routeMeta } from "@/lib/seo";
import { cityHeadScripts } from "@/lib/cityJsonLd";
import { CityHomePage } from "@/components/CityHomePage";
import hero from "@/assets/original/hero-shade.jpg";

export const Route = createFileRoute("/helotes")({
  head: (ctx) => ({
    links: [canonicalLink(pathFromMatch(ctx))],
    meta: routeMeta(ctx, {
      title: "Custom Awnings, Covers & Shade in Helotes, TX | Texas Made Shade",
      description: "Custom welded awnings, sail shades, patio & pergola covers, marine canvas and aluminum fabrication for Helotes & Bexar County.",
      image: hero,
      socialTitle: "Custom Awnings & Shade — Helotes, TX",
      socialDescription: "Welded aluminum + Sunbrella canvas. Custom shade, covers and fabrication serving Helotes and Bexar County.",
      keywords: "awnings Helotes, awning company Helotes, custom awnings Helotes, sail shades Helotes, patio covers Helotes, pergola covers Helotes, metal awnings Helotes, canvas awnings Helotes, Texas Made Shade",
    }),
    scripts: cityHeadScripts("Helotes", "Bexar County"),
  }),
  component: () => <CityHomePage city="Helotes" region="Bexar County" />,
});
